<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { required, email, minLength } from "vuelidate/lib/validators";
import MaskedInput from "vue-text-mask";
import { cloneDeep } from "lodash";
import VerificationCode from '@/components/modals/verification-code.vue';

export default {
    page: {
        title: "Account Settings",
    },
    components: {
        Layout,
        PageHeader,
        MaskedInput,
        VerificationCode,
    },
    created() {
        this.getUser();
    },
    data() {
        return {
            title: "Account Settings",
            submitted: false,
            items: [
                {
                    text: "Dashboards",
                    href: "/",
                },
                {
                    text: "Account Settings",
                    active: true,
                },
            ],
            username: JSON.parse(localStorage.getItem("user")).userName,
            password: {
                old: "",
                new: "",
                confirm: "",
            },
            alert: {
                type: "",
                message: "",
            },
            profileEmail: "",
            userProfile: { phoneNumberConfirmed: false },
            updatePhone: false,
            updateEmail: false,
            phoneNumber: "09",
            verifyType: null,
            verificationSubTitle: '',
        };
    },
    validations: {
        password: {
            old: { required },
            new: { required },
            confirm: { required },
        },
        profileEmail: { required, email },
        phoneNumber: { required, minLength: minLength(11) },
    },
    methods: {
        getUser() {
            this.$store
                .dispatch("account/GetProfile")
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    console.log(res.data);
                    if (!res.data.phoneNumber) {
                        this.phoneNumber = "09";
                    } else {
                        this.phoneNumber = cloneDeep(
                            res.data.phoneNumber
                        );
                    }
                    this.userProfile = res.data;
                    this.profileEmail = cloneDeep(res.data.email);
                })
                .catch((err) => {
                    return this.showToast(
                        "Something went wrong! - Getting User Profile",
                        "error"
                    );
                });
        },
        changePassword() {
            this.submitted = true;
            this.$v.password.$touch();
            if (this.$v.password.$invalid) {
                return;
            }
            if (this.password.new !== this.password.confirm) {
                return this.showToast(
                    "New password and confirm password does not match",
                    "error"
                );
            }
            this.$store
                .dispatch("account/ChangePassword", {
                    currentPassword: this.password.old,
                    newPassword: this.password.new,
                })
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.showToast("Password updated successfully", "success");
                    this.submitted = false;
                })
                .catch((err) => {
                    this.submitted = false;
                    this.showToast("Something went wrong!", "error");
                });
        },
        emailUpdate() {
            this.updateEmail = true;
        },
        submitEmailChanges() {
            this.$v.profileEmail.$touch();
            if (this.$v.profileEmail.$invalid) {
                return;
            }
            this.verifyEmail(this.userProfile.email, 'email');
        },
        async updateUserEmail(){
            await this.$store
                .dispatch("account/ChangeEmail", {
                    email: this.profileEmail,
                    id: this.userProfile.id,
                })
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.showToast("Email updated successfully", "success");
                    this.userProfile.email = cloneDeep(this.profileEmail);
                    this.updateEmail = false;
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        verifyEmail(email, type) {
            this.verifyType = type;
            this.$store
                .dispatch("account/SendEmailCode", {
                    email: email,
                })
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.verificationSubTitle = `Please enter the verification code sent to your email (${this.userProfile.email})`
                    this.$bvModal.show("verify-modal");
                    this.$refs.verification.initialize();
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        cancelEmailUpdate() {
            this.updateEmail = false;
            this.profileEmail = cloneDeep(this.userProfile.email);
        },
        numberUpdate() {
            this.updatePhone = true;
        },
        submitNumberChanges() {
            this.$v.phoneNumber.$touch();
            if (this.$v.phoneNumber.$invalid) {
                return;
            }
            this.verifyEmail(this.userProfile.email, 'email-number');
        },
        updatePhoneNumber(){
            this.$store
                .dispatch("account/ChangePhoneNumber", {
                    phoneNumber: this.phoneNumber.replace(/ /g, ""),
                    id: this.userProfile.applicationUserId,
                })
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.showToast("Phone Number updated successfully", "success");
                    this.userProfile.phoneNumberConfirmed = false;
                    this.userProfile.email = cloneDeep(this.phoneNumber);
                    this.updatePhone = false;
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        cancelNumberUpdate() {
            this.updatePhone = false;
            this.profileEmail = cloneDeep(this.userProfile.email);
        },
        verifyNumber() {
            this.verifyType = 'number';
            this.$store
                .dispatch("account/VerifyPhoneNumber")
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.verificationSubTitle = `Please enter the verification code sent to your phone number`
                    this.$bvModal.show("verify-modal");
                    this.$refs.verification.initialize();
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        verifyEmailCode(code, type){
            this.$store
                .dispatch("account/VerifyEmailCode", {code, applicationUserId: this.userProfile.applicationUserId} )
                .then(async (res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    if(type === 'email'){
                        await this.updateUserEmail();
                    }else{
                        await this.updatePhoneNumber();
                    }
                    this.$bvModal.hide('verify-modal')
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        verifyNumberCode(code){
            this.$store
                .dispatch("account/PhoneNumberVerification", code)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.showToast("Phone Number was successfully verified", "success");
                    this.userProfile.phoneNumberConfirmed = true;
                    this.$bvModal.hide('verify-modal')
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        verifyNow(code) {
            if(this.verifyType === 'email')
                this.verifyEmailCode(code, 'email');
            else if(this.verifyType === 'number')
                this.verifyNumberCode(code);
            else
                this.verifyEmailCode(code, 'number');
        },
    },
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <VerificationCode @dropCode="verifyNow" ref="verification" :subtitle="verificationSubTitle"/>
        <div class="row">
            <b-tabs
                pills
                vertical
                nav-class="p-0"
                nav-wrapper-class="col-sm-2"
                content-class="pt-0 px-2 text-muted"
            >
                <b-tab title-item-class="mb-2">
                    <template v-slot:title>
                        <span class="d-inline-block d-sm-none">
                            <i class="bx bx-user"></i>
                        </span>
                        <span class="d-none d-sm-inline-block"
                            ><i class="bx bx-user me-1"></i> General</span
                        >
                    </template>
                    <div class="card">
                        <div class="card-body">
                            <div class="media mb-5">
                                <div class="media-aside align-self-start me-3">
                                    <!-- <a href="#" target="_self" class=""
                                        ><img
                                            src="../../assets/images/profile-img.png"
                                            height="80"
                                            class="rounded border"
                                    /></a> -->
                                    <a
                                        href="javascript:void(0);"
                                        class="
                                            p-3
                                            d-flex
                                            align-items-center
                                            justify-content-center
                                            bg-success bg-soft
                                            text-white
                                            font-size-22
                                            rounded
                                        "
                                    >
                                        {{ username.slice(0, 2).toUpperCase() }}
                                    </a>
                                </div>
                                <div class="media-body align-self-end">
                                    <button
                                        type="button"
                                        class="btn me-1 btn-primary btn-sm"
                                    >
                                        Upload</button
                                    ><input
                                        hidden="hidden"
                                        type="file"
                                        accept=".jpg, .png, .gif"
                                        class="form-control-file"
                                        id="__BVID__1347"
                                    /><button
                                        type="button"
                                        class="
                                            btn
                                            mb-75
                                            mr-75
                                            btn-outline-secondary btn-sm
                                        "
                                    >
                                        Reset
                                    </button>
                                    <p class="card-text mt-2">
                                        Allowed JPG, GIF or PNG. Max size of
                                        800kB
                                    </p>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label for="name">First Name</label>
                                        <input
                                            autocomplete="off"
                                            type="text"
                                            class="form-control"
                                            id="fname"
                                            placeholder="First Name"
                                            v-model="userProfile.firstName"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label for="name">Middle Name</label>
                                        <input
                                            autocomplete="off"
                                            type="text"
                                            class="form-control"
                                            id="mname"
                                            placeholder="Middle Name"
                                            v-model="userProfile.middleName"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label for="name">Last Name</label>
                                        <input
                                            autocomplete="off"
                                            type="text"
                                            class="form-control"
                                            id="lname"
                                            placeholder="Last Name"
                                            v-model="userProfile.lastName"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <label for="email">Email</label>
                                    <b-input-group>
                                        <template #append>
                                            <b-button
                                                @click="emailUpdate"
                                                variant="outline-info"
                                                v-if="!updateEmail"
                                                ><i class="bx bx-edit"></i
                                            ></b-button>
                                            <b-button
                                                v-if="updateEmail"
                                                @click="submitEmailChanges"
                                                variant="outline-success"
                                                ><i class="bx bx-check"></i
                                            ></b-button>
                                            <b-button
                                                v-if="updateEmail"
                                                @click="cancelEmailUpdate"
                                                variant="outline-danger"
                                                ><i class="bx bx-x"></i
                                            ></b-button>
                                        </template>
                                        <input
                                            autocomplete="off"
                                            type="email"
                                            class="form-control"
                                            id="email"
                                            placeholder="Email"
                                            v-model="profileEmail"
                                            :disabled="!updateEmail"
                                            :class="{
                                                'is-invalid':
                                                    $v.profileEmail.$error,
                                            }"
                                        />
                                    </b-input-group>
                                    <div
                                        v-if="$v.profileEmail.$error"
                                        class="invalid-feedback"
                                    >
                                        <span v-if="!$v.profileEmail.required"
                                            >This value is required.</span
                                        >
                                        <span v-if="!$v.profileEmail.email"
                                            >Must be email format.</span
                                        >
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label for="phoneNumber"
                                            >Phone Number</label
                                        >
                                        <b-input-group>
                                            <template #append>
                                                <b-button
                                                    @click="numberUpdate"
                                                    variant="outline-info"
                                                    v-if="!updatePhone"
                                                    ><i class="bx bx-edit"></i
                                                ></b-button>
                                                <b-button
                                                    v-if="updatePhone"
                                                    @click="submitNumberChanges"
                                                    variant="outline-success"
                                                    ><i class="bx bx-check"></i
                                                ></b-button>
                                                <b-button
                                                    v-if="updatePhone"
                                                    @click="cancelNumberUpdate"
                                                    variant="outline-danger"
                                                    ><i class="bx bx-x"></i
                                                ></b-button>
                                            </template>
                                            <masked-input
                                                autocomplete="off"
                                                type="text"
                                                class="form-control"
                                                id="phoneNumber"
                                                placeholder="Phone Number"
                                                v-model="phoneNumber"
                                                :mask="[
                                                    /[0-9]/,
                                                    /\d/,
                                                    /\d/,
                                                    /\d/,
                                                    ' ',
                                                    /\d/,
                                                    /\d/,
                                                    /\d/,
                                                    ' ',
                                                    /\d/,
                                                    /\d/,
                                                    /\d/,
                                                    /\d/,
                                                ]"
                                                :guide="false"
                                                :disabled="!updatePhone"
                                                :class="{
                                                'is-invalid':
                                                    $v.phoneNumber.$error,
                                                }"
                                            ></masked-input>
                                        </b-input-group>
                                        <div
                                            v-if="$v.phoneNumber.$error"
                                            class="invalid-feedback"
                                        >
                                            <span
                                                v-if="!$v.phoneNumber.required"
                                                >This value is required.</span
                                            >
                                            <span
                                                v-if="!$v.phoneNumber.minLength"
                                                >Must be 11 digit.</span
                                            >
                                        </div>
                                        <div
                                            v-if="
                                                !userProfile
                                                    .phoneNumberConfirmed
                                            "
                                        >
                                            <small class="text-warning">
                                                <i
                                                    class="bx bx-info-circle"
                                                ></i>
                                                <i>Verify Phone Number</i>
                                                <a
                                                    href="javascript:void(0);"
                                                    class="ms-1"
                                                    @click="verifyNumber"
                                                    >[Click here to verify]</a
                                                >
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr />
                            <div class="text-right">
                                <button type="submit" class="btn btn-primary">
                                    <i class="bx bx-save me-1"></i> Save Changes
                                </button>
                            </div>
                        </div>
                    </div>
                </b-tab>
                <b-tab title-item-class="mb-2">
                    <template v-slot:title>
                        <span class="d-inline-block d-sm-none">
                            <i class="bx bx-lock"></i>
                        </span>
                        <span class="d-none d-sm-inline-block"
                            ><i class="bx bx-lock me-1"></i> Password</span
                        >
                    </template>
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label for="old">Old Password</label>
                                        <input
                                            autocomplete="off"
                                            type="password"
                                            class="form-control"
                                            id="old"
                                            placeholder="Old Password"
                                            v-model="password.old"
                                            :class="{
                                                'is-invalid':
                                                    submitted &&
                                                    $v.password.old.$error,
                                            }"
                                        />
                                        <div
                                            v-if="
                                                submitted &&
                                                $v.password.old.$error
                                            "
                                            class="invalid-feedback"
                                        >
                                            <span
                                                v-if="!$v.password.old.required"
                                                >This value is required.</span
                                            >
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label for="new">New Password</label>
                                        <input
                                            autocomplete="off"
                                            type="password"
                                            class="form-control"
                                            id="new"
                                            placeholder="New Password"
                                            v-model="password.new"
                                            :class="{
                                                'is-invalid':
                                                    submitted &&
                                                    $v.password.new.$error,
                                            }"
                                        />
                                        <div
                                            v-if="
                                                submitted &&
                                                $v.password.new.$error
                                            "
                                            class="invalid-feedback"
                                        >
                                            <span
                                                v-if="!$v.password.new.required"
                                                >This value is required.</span
                                            >
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label for="confirm"
                                            >Retype New Password</label
                                        >
                                        <input
                                            autocomplete="off"
                                            type="password"
                                            class="form-control"
                                            id="confirm"
                                            placeholder="Retype New Password"
                                            v-model="password.confirm"
                                            :class="{
                                                'is-invalid':
                                                    submitted &&
                                                    $v.password.confirm.$error,
                                            }"
                                        />
                                        <div
                                            v-if="
                                                submitted &&
                                                $v.password.confirm.$error
                                            "
                                            class="invalid-feedback"
                                        >
                                            <span
                                                v-if="
                                                    !$v.password.confirm
                                                        .required
                                                "
                                                >This value is required.</span
                                            >
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr />
                            <div class="text-right">
                                <button
                                    type="button"
                                    @click="changePassword"
                                    class="btn btn-primary"
                                >
                                    <i class="bx bx-save me-1"></i> Save Changes
                                </button>
                            </div>
                        </div>
                    </div>
                </b-tab>
            </b-tabs>
        </div>
    </Layout>
</template>